import React from 'react';
import Breadcrumb from '../components/common/Breadcrumb';
import { Col, Container, Row } from 'reactstrap';

import about from '../assets/images/about-img.png';
import globe from '../assets/images/banner_shape01.png';

export default function About() {
  return (
    <>
      <Breadcrumb title="About Us" page="About" />
      <section id="about" className="section-wrapper bg-primary-light">
        <Container>
          <div className="content-inner-1">
            <Row className="align-items-center justify-content-center">
              <Col lg={6}>
                <div className="about-img wow fadeInLeft" data-wow-delay=".2s">
                  <img src={about} alt="about" />
                  <img className="about-left-image" src={globe} alt="about" />
                </div>
              </Col>
              <Col lg={6}>
                <div
                  className="about-content wow fadeInRight"
                  data-wow-delay=".5s"
                >
                  <div className="section-head">
                    <h2 className="title">About us</h2>
                    <p>MCGPchain Green Protocol overview</p>
                  </div>
                  <div className="about-text">
                    <p>
                      MCGP is a community driven project own and is for the
                      community. MCGP stands in line with actualization of
                      Tokenization and RWA market valuation of $16 Trillion
                      dollars worth in 2030. As a growing community, we believe
                      to work towards bringing a transparent Tokenization
                      ecosystem platform which will foster a simple and easy go
                      of tokenizing real world assets across globe.
                    </p>
                    <p>
                      Tokenization is the process of converting real-world
                      assets into digital tokens, enabling fractional ownership
                      and increased liquidity. As the MCGP project aims to
                      become the world-leading Tokenization platform, our goal
                      is to revolutionize the way assets are bought, sold, and
                      traded. By providing a secure and transparent platform for
                      tokenizing various assets such as real estate,
                      Agricultural products, securities, and other Real world
                      assets!MCGP is bridging the gap between traditional
                      finance and the digital economy. Through our innovative
                      technology and commitment to compliance, we are empowering
                      investors to diversify their portfolios and access new
                      investment opportunities in a seamless and efficient
                      manner.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
}
